import { render, staticRenderFns } from "./TotalPending.vue?vue&type=template&id=7f1da873&"
import script from "./TotalPending.vue?vue&type=script&lang=js&"
export * from "./TotalPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports